import React from "react";

import { IProductTemplateTableEditor } from "components/ComponentTypeTypes";
import { InputNumber } from "primereact/inputnumber";
import { T } from "services/lang/LanguageService";
import TimeSpanInputs from "components/fragments/product-template-configurator/ProductTemplateAttributesConfiguration/type-fields/components/TimeSpanInputs";

type ProductTemplateConfigProps = {
  currentConfig: IProductTemplateTableEditor;
  setCurrentConfig: React.Dispatch<React.SetStateAction<IProductTemplateTableEditor>>;
};

const ProductTemplateConfig: React.FC<ProductTemplateConfigProps> = ({ currentConfig, setCurrentConfig }) => {
  return (
    <div className="flex flex-row gap-2">
      <div className="w-full flex flex-wrap md:flex-nowrap gap-2 mb-3">
        <div className="gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="itemsPerPage">{T("component.items-per-page")}</label>
          <InputNumber
            id="itemsPerPage"
            value={currentConfig?.itemsPerPage}
            onChange={e => setCurrentConfig({ ...currentConfig, itemsPerPage: e.value ?? 0 })}
          />
        </div>
        <div className="gap-2 flex flex-column justify-content-center align-items-center">
          <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
          <div className="p-inputgroup">
            <InputNumber
              id="updateFrequency"
              value={currentConfig?.updateFrequency as number}
              onChange={e => setCurrentConfig({ ...currentConfig, updateFrequency: e.value ?? 0 })}
            />
            <span className="p-inputgroup-addon">s</span>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap md:flex-nowrap gap-3 mb-3">
        <div className="gap-2 flex flex-column justify-content-center">
          <label>{`${T("word.datasets")} ${T("word.max")} ${T("word.age").toLowerCase()}`}</label>
          <div className="p-inputgroup">
            <TimeSpanInputs
              value={currentConfig.maxAge ?? 0}
              onChange={val => setCurrentConfig({ ...currentConfig, maxAge: val })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTemplateConfig;
